export default {
    define: "+proj=tmerc +lat_0=39.865766 +lon_0=116.35025181 +k=1 +x_0=500000 +y_0=300000 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs",
    extent: [496640.4223081192, 299832.38534722617, 503928.0891231192, 312018.52288222616],//北京市范围
    initExtent: [496640.4223081192, 299832.38534722617, 503928.0891231192, 312018.52288222616],//北京市范围
    units: "meters",
    // tile_matrixIds: ['EPSG:990000:0', 'EPSG:990000:1', 'EPSG:990000:2',
    //     'EPSG:990000:3', 'EPSG:990000:4', 'EPSG:990000:5', 'EPSG:990000:6',
    //     'EPSG:990000:7', 'EPSG:990000:8', 'EPSG:990000:9', 'EPSG:990000:10',
    //     'EPSG:990000:11', 'EPSG:990000:12', 'EPSG:990000:13'],
    // tile_resolutions: [728.7020559313455, 364.35102796567276, 182.17551398283638,
    //     91.08775699141819, 45.543878495709095, 22.771939247854547,
    //     11.385969623927274, 5.692984811963637, 2.8464924059818184,
    //     1.4232462029909092, 0.7116231014954546, 0.3558115507477273,
    //     0.1779057753738637, 0.0889528876869318],
    // origin: [418170.1454912898, 439251.4664480498],
    tile_matrixIds: ['EPSG:990000:0', 'EPSG:990000:1', 'EPSG:990000:2',
        'EPSG:990000:3', 'EPSG:990000:4', 'EPSG:990000:5', 'EPSG:990000:6',
        'EPSG:990000:7', 'EPSG:990000:8'],
    tile_resolutions: [67.733468800270941, 33.866734400135471, 16.933367200067735, 8.4666836000338677, 4.2333418000169338, 2.1166709000084669, 1.0583354500042335, 0.52916772500211673, 0.26458386250105836],
    origin: [-5123300, 5887600],
}